'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import I18n from 'I18n';
import styled from 'styled-components';
import UIAccordionItem from 'UIComponents/accordion/UIAccordionItem';
import { jsx as _jsx } from "react/jsx-runtime";
const FavoritesContainer = styled.div.withConfig({
  displayName: "FavoritesAccordion__FavoritesContainer",
  componentId: "n38h92-0"
})(["display:inline-flex;"]);
const FavoriteSquatch = styled.div.withConfig({
  displayName: "FavoritesAccordion__FavoriteSquatch",
  componentId: "n38h92-1"
})(["display:inline-block;position:relative;overflow:hidden;background-color:", ";height:15px;width:15px;border-radius:2px;box-shadow:0 0 2px #808080 inset;cursor:pointer;&:not(:last-child){margin-right:8px;}"], ({
  backgroundColor
}) => backgroundColor);
class FavoritesAccordion extends Component {
  onClickFavorite(hex) {
    const {
      onSelectColor
    } = this.props;
    onSelectColor({
      hex
    });
  }
  render() {
    const {
      favorites = []
    } = this.props;
    if (favorites.length <= 0) return null;
    const favoritesComponents = favorites.map((color, index) => {
      const handleClick = () => {
        this.onClickFavorite(color);
      };
      return /*#__PURE__*/_jsx(FavoriteSquatch, {
        "data-test-id": "favorites-accordion-squatch",
        backgroundColor: color,
        onClick: handleClick
      }, `favorite-${index}`);
    });
    return /*#__PURE__*/_jsx(UIAccordionItem, {
      "data-test-id": "favorites-accordion",
      defaultOpen: true,
      className: "m-top-2",
      flush: true,
      title: I18n.text('colorPicker.favorites'),
      children: /*#__PURE__*/_jsx(FavoritesContainer, {
        children: favoritesComponents
      })
    });
  }
}
FavoritesAccordion.propTypes = {
  favorites: PropTypes.arrayOf(PropTypes.string),
  onSelectColor: PropTypes.func.isRequired
};
export default FavoritesAccordion;